import { z } from 'zod';
var BaseSchemaChange = z.object({
    who: z.union([z.string(), z.any()]).optional(),
    when: z.union([z.string().transform(function (v) { return new Date(Date.parse(v)); }), z.date()])
});
export var BaseSchema = z.object({
    _id: z.union([z.string(), z.any().transform(function (v) { return v.toString(); })]),
    _createdBy: BaseSchemaChange.optional(),
    _updatedBy: BaseSchemaChange.optional(),
    _deletedAt: z.date().optional()
});
